import { useRef, useState } from "react";
import { toast } from "sonner";
import { ImagePlus, X } from "lucide-react";
import { api, errMsg, fileUrl } from "../lib/api";
import { inputCls } from "./ui";

export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/upload", fd);
  return data.url;
};

export const ImageField = ({ value, onChange, testid = "featured-image" }) => {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const pick = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      onChange(await uploadImage(f));
      toast.success("Image uploaded");
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); e.target.value = ""; }
  };
  return (
    <div data-testid={testid}>
      {value ? (
        <div className="relative overflow-hidden rounded-xl border border-[#D4AF37]/25">
          <img src={fileUrl(value)} alt="Featured" className="aspect-[16/9] w-full object-cover" data-testid={`${testid}-preview`} />
          <button type="button" onClick={() => onChange("")} className="absolute right-2 top-2 rounded-full bg-black/70 p-1.5 text-white" aria-label="Remove image" data-testid={`${testid}-remove`}><X size={14} /></button>
        </div>
      ) : (
        <button type="button" onClick={() => ref.current.click()} disabled={busy} data-testid={`${testid}-upload`}
          className="grid aspect-[16/9] w-full place-items-center rounded-xl border-2 border-dashed border-[#D4AF37]/30 text-sm text-zinc-500 transition-colors hover:border-[#D4AF37]">
          <span className="flex flex-col items-center gap-2"><ImagePlus className="text-[#D4AF37]" />{busy ? "Uploading…" : "Upload image (JPG, PNG, WEBP)"}</span>
        </button>
      )}
      <input ref={ref} type="file" accept="image/jpeg,image/png,image/webp,image/gif,image/x-icon,.ico" className="hidden" onChange={pick} data-testid={`${testid}-input`} />
      <input value={value} onChange={(e) => onChange(e.target.value)} placeholder="…or paste an image URL" className={`${inputCls} mt-2`} data-testid={`${testid}-url`} />
    </div>
  );
};
